import React, { useEffect, useState } from "react";
import { Table, TableHead, TableHeadCell, TableBody } from "flowbite-react";
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import './searchTroc.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons/faCirclePlus";
import { faCircleMinus } from "@fortawesome/free-solid-svg-icons/faCircleMinus";
import { ProfilUserWhenSearchTroc } from "../modales/profilModal/ProfilUserWhenSearchTroc";
import { ISearchTrocResidentExtended, searchTrocs } from "../../services/interfaces/ITrocResident2";
import { AskToTrade } from "../modales/askToTrade/AskToTrade";
import BtnLikerTroc from '../buttons/btnRes/BtnLikerTroc';
import IndicateServiceNeedName from "../indicateSerNeedName/IndicateSerNeedName";

interface ExtraProps {
  setRTrocsList?: React.Dispatch<React.SetStateAction<ISearchTrocResidentExtended[]>>;
}

function SearchTrocsTable(props: searchTrocs & ExtraProps) {
  //destructuring
  const { trocsResidents, trocsTravelers, triggerUseEffect, settriggerUseEffect, setRTrocsList } = props;

  const [expandedRowIndex, setExpandedRowIndex] = useState<number | null>(null);
  const [selectedRow, setSelectedRow] = useState<number>();
  const [iconStates, setIconStates] = useState<boolean[]>([]);
  const [serviceNeedName, setServiceNeedName] = useState<string | null>("");
  const [isIndicateServiceNeedName, setisIndicateServiceNeedName] = useState<boolean>(false);

  //get user role via redux
  const userRole = useSelector((state: RootState) => state.user.role);

  function handleExpandedRow(index: number) {
    // Si la ligne est déjà étendue, la rétracter
    if (expandedRowIndex === index) {
      setExpandedRowIndex(null); // Rétracte la ligne
    } else {
      setExpandedRowIndex(index); // Étend la nouvelle ligne
    }
  }

  function handleSwitchIcon(rowNumber: number) {
    setSelectedRow(rowNumber);

    // Inverse l'état de l'icône pour la ligne cliquée
    setIconStates(prev => {
      const newState = [...prev];

      //asign false to icon selected to display a minus
      newState[rowNumber] = false;

      //compare iconStates initiale vs newsState
      if (prev[rowNumber] === newState[rowNumber]) {//si cliqué au meme endroit

        //asign true to icon selected to display a Plus
        newState[rowNumber] = true;

        return newState;

      }
      else {//si pas cliqué au meme endroit

        const newsState2 = newState.map(() => true);

        newsState2[rowNumber] = false;

        return newsState2;
      }
    });
  }

  //function to formated date
  const formatedDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear().toString().slice(-2);

    return `${day}/${month}/${year}`;
  };

  const handleClickToIndicateServNeedName = (serviceOrNeeedName: string | null) => {
    setServiceNeedName(serviceOrNeeedName);
    setisIndicateServiceNeedName(true);
  };

  //useeffect to switch icon
  useEffect(() => {
    const totalLength = (trocsResidents?.length || 0) + (trocsTravelers?.length || 0);
    setIconStates(new Array(totalLength).fill(true));
  }, [trocsResidents, trocsTravelers]);

  return (
    <>
      <Table hoverable className="w-full table-auto table-ask-troc">

        {/* thead part */}
        <TableHead className="sticky top-0 text-base text-white" id='tablehead-thead'>
          <TableHeadCell id='tableheadcell-th-res' className="bg-orangeCustom text-center rounded-l-xl">{userRole === 'TRAVELER' ? "RESIDENTS" : "VOYAGEURS"}</TableHeadCell>
          <TableHeadCell id='tableheadcell-th-title' className="bg-orangeCustom text-center">TITRE</TableHeadCell>
          <TableHeadCell id='tableheadcell-th-services' className="bg-orangeCustom text-center">SES SERVICES</TableHeadCell>
          <TableHeadCell id='tableheadcell-th-needs' className="bg-orangeCustom text-center tableheadcell-th-needs">SES BESOINS</TableHeadCell>
          <TableHeadCell id="tableheadcell-th-vide" className="bg-orangeCustom text-orangeCustom rounded-r-xl w-16">Action</TableHeadCell>
        </TableHead>

        {/* tbody part */}
        <TableBody className="divide-y text-sm">

          {/* res trocs */}
          {trocsResidents?.map((trocResident, index) => (
            <React.Fragment key={index}>
              <tr className={`${selectedRow === index && expandedRowIndex === index ? "bg-gray-200" : "bg-white"} cursor-pointer hover:bg-gradient-to-b hover:from-gray-200 hover:to-gray-100`} onClick={() => { handleExpandedRow(index), handleSwitchIcon(index) }}>

                <td className="td-pseudo text-center">
                  <ProfilUserWhenSearchTroc id={trocResident.id} pseudo={trocResident.pseudo} presentation={trocResident.presentation} number_troc_done={trocResident.number_troc_done} last3Comments={trocResident.last3Comments} flexible={trocResident.flexible} badges={trocResident.badgeNames} />
                </td>

                <td className="td-title text-center font-medium text-gray-900 dark:text-white">
                  {trocResident.title}
                </td>

                <td className="td-services">
                  <div id="services" className="flex justify-center flex-wrap gap-2 p-2">
                    {trocResident.r_service1_name && (
                      <img className="h-20 w-20" src={`/besoinsDuNomade-servicesDuRésident/${trocResident.r_service1_name}.png`} alt="service 1" onClick={() => handleClickToIndicateServNeedName(trocResident.r_service1_name)} />
                    )}

                    {trocResident.r_service2_name && (
                      <img className="h-20 w-20" src={`/besoinsDuNomade-servicesDuRésident/${trocResident.r_service2_name}.png`} alt="service 2" onClick={() => handleClickToIndicateServNeedName(trocResident.r_service2_name)} />
                    )}

                    {trocResident.r_service3_name && (
                      <img className="h-20 w-20" src={`/besoinsDuNomade-servicesDuRésident/${trocResident.r_service3_name}.png`} alt="service 3" onClick={() => handleClickToIndicateServNeedName(trocResident.r_service3_name)} />
                    )}
                  </div>
                </td>

                <td className="td-needs">
                  <div id="needs" className="flex justify-center flex-wrap gap-2">
                    {trocResident.r_need1_name && (
                      <img className="h-20 w-20" src={`/servicesDuNomade-besoinsDuRésident/${trocResident.r_need1_name}.png`} alt="service 1" onClick={() => handleClickToIndicateServNeedName(trocResident.r_need1_name)} />
                    )}

                    {trocResident.r_need2_name && (
                      <img className="h-20 w-20" src={`/servicesDuNomade-besoinsDuRésident/${trocResident.r_need2_name}.png`} alt="service 2" onClick={() => handleClickToIndicateServNeedName(trocResident.r_need2_name)} />
                    )}

                    {trocResident.r_need3_name && (
                      <img className="h-20 w-20" src={`/servicesDuNomade-besoinsDuRésident/${trocResident.r_need3_name}.png`} alt="service 3" onClick={() => handleClickToIndicateServNeedName(trocResident.r_need3_name)} />
                    )}

                  </div>
                </td>

                <td className="td-icone-plus text-center">
                  <div>
                    <FontAwesomeIcon className="text-greenCustom h-6 w-6" icon={iconStates[index] ? faCirclePlus : faCircleMinus} />
                  </div>
                </td>

              </tr>

              {/* expanded row part */}
              {expandedRowIndex === index && (
                <>
                  <tr id='tr-detail-up' className="text-black">
                    <td colSpan={5} className="td1-detail-up">

                      <div id='div-date-place' className="flex flex-col justify-around items-center gap-2">

                        <div id="start-end-date" className='font-medium text-center'>
                          <p>Du {formatedDate(trocResident.start_time)} au {formatedDate(trocResident.end_time)}</p>
                        </div>

                        <div id="place" className="text-center">
                          <p>Département: {trocResident.departement ? trocResident.departement : "non renseigné"}</p>
                        </div>

                      </div>

                    </td>
                  </tr>

                  <tr id='tr-detail-middle'>
                    <td colSpan={5} className="td2-detail-middle">

                      <div id='div-services-needs' className='flex flex-col'>

                        {/* services */}
                        <div id="services-detail-up" className="w-full flex flex-col">

                          <p className='flex justify-center font-medium text-black'>Ses services</p>

                          <div className="w-full flex flex-wrap justify-center gap-4 p-2">
                            {trocResident.r_service1_name && (
                              <img className="h-20 w-20" src={`/besoinsDuNomade-servicesDuRésident/${trocResident.r_service1_name}.png`} alt="service 1" onClick={() => handleClickToIndicateServNeedName(trocResident.r_service1_name)} />
                            )}

                            {trocResident.r_service2_name && (
                              <img className="h-20 w-20" src={`/besoinsDuNomade-servicesDuRésident/${trocResident.r_service2_name}.png`} alt="service 2" onClick={() => handleClickToIndicateServNeedName(trocResident.r_service2_name)} />
                            )}

                            {trocResident.r_service3_name && (
                              <img className="h-20 w-20" src={`/besoinsDuNomade-servicesDuRésident/${trocResident.r_service3_name}.png`} alt="service 3" onClick={() => handleClickToIndicateServNeedName(trocResident.r_service3_name)} />
                            )}

                          </div>

                        </div>

                        {/* needs */}
                        <div id="needs-detail-up" className="w-full flex flex-col">

                          <p className='flex justify-center font-medium text-black'>Ses besoins</p>

                          <div className="w-full flex flex-wrap justify-center gap-4 px-2 pt-2">
                            {trocResident.r_need1_name && (
                              <img className="h-20 w-20" src={`/servicesDuNomade-besoinsDuRésident/${trocResident.r_need1_name}.png`} alt="service 1" onClick={() => handleClickToIndicateServNeedName(trocResident.r_need1_name)} />
                            )}

                            {trocResident.r_need2_name && (
                              <img className="h-20 w-20" src={`/servicesDuNomade-besoinsDuRésident/${trocResident.r_need2_name}.png`} alt="service 2" onClick={() => handleClickToIndicateServNeedName(trocResident.r_need2_name)} />
                            )}

                            {trocResident.r_need3_name && (
                              <img className="h-20 w-20" src={`/servicesDuNomade-besoinsDuRésident/${trocResident.r_need3_name}.png`} alt="service 3" onClick={() => handleClickToIndicateServNeedName(trocResident.r_need3_name)} />
                            )}
                          </div>

                        </div>

                      </div>
                    </td>
                  </tr>

                  <tr id='tr-detail-down' className="border-none text-black">
                    <td colSpan={5} className="td3-detail-down">

                      {/*separator row  */}
                      <span className="separator border-t-0 border-gray-300 block m-3" />

                      {/* Decription du troc and actions*/}
                      <div className="flex flex-col items-center justify-around gap-4">

                        {/* description */}
                        <div id="div-descript-actions" className='flex flex-col gap-1 w-full items-center'>

                          <h2 className='font-medium text-center'>Description du troc :</h2>

                          <div id="div-descript" className="overflow-y-auto w-full px-2">
                            <textarea
                              className="break-words w-full border-4 rounded-md"
                              value={trocResident.description}
                              rows={3}
                              readOnly
                            />
                          </div>

                        </div>

                        {/* actions */}
                        <div id="offering-troc">
                          <AskToTrade pseudo={trocResident.pseudo} resTrocId={trocResident.id} settriggerUseEffect={settriggerUseEffect} setRTrocsList={setRTrocsList} setExpandedRowIndex={setExpandedRowIndex} />
                        </div>

                      </div>

                    </td>
                  </tr>
                </>
              )}
            </React.Fragment>
          ))}

          {/* trav trocs */}
          {trocsTravelers?.map((trocTraveler, index) => (
            <React.Fragment key={index}>
              <tr className={`${selectedRow === index && expandedRowIndex === index ? "bg-gray-200" : "bg-white"} cursor-pointer hover:bg-gradient-to-b hover:from-gray-200 hover:to-gray-100`} onClick={() => { handleExpandedRow(index), handleSwitchIcon(index) }}>

                <td className="td-pseudo text-center">
                  <ProfilUserWhenSearchTroc id={trocTraveler.id} pseudo={trocTraveler.pseudo} presentation={trocTraveler.presentation} number_troc_done={trocTraveler.number_troc_done} last3Comments={trocTraveler.last3Comments} flexible={trocTraveler.flexible} badges={trocTraveler.badgeNames} />
                </td>

                <td className="td-title text-center font-medium text-gray-900 dark:text-white">
                  {trocTraveler.title}
                </td>

                <td className="td-services">
                  <div id="services" className="flex justify-center flex-wrap gap-2 p-2">
                    {trocTraveler.services
                      .filter((service) => service != null)
                      .map((service, index) => (
                        <img
                          key={index}
                          className="h-20 w-20 cursor-pointer"
                          src={`${"/servicesDuNomade-besoinsDuRésident/" + service + ".png"}`}
                          alt={`image ${service}`}
                          onClick={() => handleClickToIndicateServNeedName(service)}
                        />
                      ))
                    }
                  </div>
                </td>

                <td className="td-needs">
                  <div id="needs" className="flex justify-center flex-wrap gap-2">
                    {trocTraveler.needs
                      .filter((need) => need != null)
                      .map((need, index) => (
                        <img
                          key={index}
                          className="h-20 w-20 cursor-pointer"
                          src={`${"/besoinsDuNomade-servicesDuRésident/" + need + ".png"}`}
                          alt={`image ${need}`}
                          onClick={() => handleClickToIndicateServNeedName(need)}
                        />
                      ))
                    }
                  </div>
                </td>

                <td id={`td-icon-plus${index}`} className="td-icone-plus text-center">
                  <FontAwesomeIcon className="text-greenCustom h-6 w-6" icon={iconStates[index] ? faCirclePlus : faCircleMinus} />
                </td>

              </tr>

              {/* expanded row part */}
              {expandedRowIndex === index && (
                <>
                  <tr id='tr-detail-up' className="text-black">
                    <td colSpan={5} className="td1-detail-up">

                      <div id='div-date-actions' className="flex justify-around items-center">

                        <div id="start-end-date" className='font-medium text-center'>
                          <p>Du {formatedDate(trocTraveler.start_time.toString())} au {formatedDate(trocTraveler.end_time.toString())}</p>
                        </div>

                        {/* actions */}
                        <div id="div-liker-up" className='hidden'>
                          <BtnLikerTroc travTrocId={trocTraveler.id} isLikedByRes={trocTraveler.isLikedByRes} triggerUseEffect={triggerUseEffect} settriggerUseEffect={settriggerUseEffect} />
                        </div>

                      </div>
                    </td>
                  </tr>

                  <tr id='tr-detail-middle'>
                    <td colSpan={5} className="td2-detail-middle">

                      <div id='div-services-needs' className='flex flex-col'>

                        {/* services */}
                        <div id="services-detail-up" className="w-full flex flex-col">

                          <p className='flex justify-center font-medium text-black'>Ses services</p>

                          <div className="w-full flex flex-wrap justify-center gap-4 p-2">
                            {trocTraveler.services
                              .filter((service) => service != null)
                              .map((service, index) => (
                                <img
                                  key={index}
                                  className="h-20 w-20 cursor-pointer"
                                  src={`${"/servicesDuNomade-besoinsDuRésident/" + service + ".png"}`}
                                  alt={`image ${service}`}
                                  onClick={() => handleClickToIndicateServNeedName(service)}
                                />
                              ))
                            }
                          </div>

                        </div>

                        {/* needs */}
                        <div id="needs-detail-up" className="w-full flex flex-col">

                          <p className='flex justify-center font-medium text-black'>Ses besoins</p>

                          <div className="w-full flex flex-wrap justify-center gap-4 p-2">
                            {trocTraveler.needs
                              .filter((need) => need != null)
                              .map((need, index) => (
                                <img
                                  key={index}
                                  className="h-20 w-20 cursor-pointer"
                                  src={`${"/besoinsDuNomade-servicesDuRésident/" + need + ".png"}`}
                                  alt={`image ${need}`}
                                  onClick={() => handleClickToIndicateServNeedName(need)}
                                />
                              ))
                            }
                          </div>

                        </div>

                      </div>
                    </td>
                  </tr>

                  <tr id='tr-detail-down' className="border-none text-black">
                    <td colSpan={5} className="td3-detail-down">

                      {/*separator row  */}
                      <span className="separator border-t-0 border-gray-300 block m-3" />

                      {/* Decription du troc and actions*/}
                      <div className="flex flex-col items-center justify-around gap-4">

                        {/* description */}
                        <div id="div-descript-actions" className='flex flex-col gap-1 w-full items-center'>

                          <h2 className='font-medium text-center'>Description du troc :</h2>

                          <div id="div-descript" className="overflow-y-auto w-full px-2">
                            <textarea
                              className="break-words w-full border-4 rounded-md"
                              value={trocTraveler.description}
                              rows={3}
                              readOnly
                            />
                          </div>

                        </div>

                        {/* actions */}
                        <div id="div-liker" className='w-full flex justify-end'>
                          <BtnLikerTroc travTrocId={trocTraveler.id} isLikedByRes={trocTraveler.isLikedByRes} triggerUseEffect={triggerUseEffect} settriggerUseEffect={settriggerUseEffect} />
                        </div>

                      </div>

                    </td>
                  </tr>
                </>
              )}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
      {/* Fenêtre modale */}
      {isIndicateServiceNeedName && <IndicateServiceNeedName name={serviceNeedName} setisIndicateServiceNeedName={setisIndicateServiceNeedName} />}
    </ >
  )
}
export default SearchTrocsTable;